module.exports = __webpack_public_path__ + "media/music/synth_chords_0-efee20fc.mp3";